module.exports = __webpack_public_path__ + "static/img/event-default-bg.04b771ba.png";